module.exports = __webpack_public_path__ + "media/images/flags/64/Christmas-Island-e70b553819e6737f530276b859e16421.png";